<bxi-page
  [title]="('device.list.title' | translate) + totalCount()"
  [supportingTitle]="'device.list.supportingTitle' | translate"
  [breadcrumbOptions]="breadcrumbOptions()"
  class="h-screen w-full"
>
  <bxi-device-list-grid class="h-full w-full" (totalCountChange)="handleTotalCountChange($event)" />
</bxi-page>
